import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { ArrowRight, type LucideIcon } from "lucide-react";
import type { ComponentPropsWithRef, JSX } from "react";

type NextStepCardProps = ComponentPropsWithRef<typeof Button> & {
  icon: LucideIcon;
  label: string;
  description: string;
};

export function NextStepCard({
  icon: Icon,
  label,
  description,
  ...props
}: NextStepCardProps): JSX.Element {
  return (
    <Button
      type="button"
      variant="ghost"
      {...props}
      className="group flex h-auto w-full items-center gap-4 rounded-lg border border-border bg-card px-4 py-3 text-left transition-all duration-150 hover:bg-accent hover:shadow-sm"
    >
      <Icon
        aria-hidden
        className="size-5 shrink-0 text-muted-foreground transition-colors group-hover:text-foreground"
        strokeWidth={2}
      />
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="font-medium text-foreground text-sm leading-snug">
          {label}
        </span>
        <span className="text-muted-foreground text-sm leading-relaxed">
          {description}
        </span>
      </span>
      <ArrowRight
        aria-hidden
        className="size-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5"
      />
    </Button>
  );
}
